<div class="equipment-uptime-card" *ngIf="isEquipmentUptimeLayout(); else defaultHorizontalBarChart">
  <header class="equipment-uptime-header">
    <div class="equipment-uptime-title-row">
      <h2>{{ equipmentUptimeTitle }}</h2>
      <span class="equipment-unit-badge" *ngIf="equipmentUptimeUnit">{{ equipmentUptimeUnit }}</span>
    </div>
    <div class="equipment-subtitle" *ngIf="equipmentUptimeSubtitle">{{ equipmentUptimeSubtitle }}</div>
  </header>

  <div class="equipment-body" *ngIf="!hasError; else equipmentError">
    <div class="equipment-rows">
      <div class="equipment-average" *ngIf="equipmentUptimeAverage" [style.left.%]="getAveragePosition()">
        <span>{{ equipmentUptimeAverage.label }}</span>
      </div>

      <div class="equipment-row" *ngFor="let row of equipmentUptimeRows">
        <div class="equipment-row-label">{{ row.label }}</div>
        <div class="equipment-bar-track">
          <div
            class="equipment-bar"
            [style.width.%]="getEquipmentBarWidth(row.value)">
          </div>
        </div>
        <div class="equipment-row-value">{{ getRowDisplayValue(row) }}</div>
      </div>
    </div>

    <div class="equipment-axis-label" *ngIf="equipmentUptimeAxisLabel">{{ equipmentUptimeAxisLabel }}</div>
  </div>

  <footer class="equipment-footer" *ngIf="equipmentUptimeMetrics.length">
    <div class="equipment-footer-metric" *ngFor="let metric of equipmentUptimeMetrics">
      <span class="equipment-footer-label">{{ metric.label }}</span>
      <span class="equipment-footer-value" [ngClass]="getMetricClass(metric)">
        {{ formatEquipmentMetric(metric) }}
      </span>
    </div>
  </footer>
</div>

<ng-template #equipmentError>
  <div class="horizontal-bar-card__error">
    <app-data-error [message]="errorMessage" />
  </div>
</ng-template>

<ng-template #defaultHorizontalBarChart>
<div class="card horizontal-bar-card mb-5">
  <div class="card-body horizontal-bar-card__body">
    <div
      [id]="data.widgetId"
      [style.height]="data?.height || '36vh'"
      [class.horizontal-bar-card__chart--hidden]="hasError"
      class="horizontal-bar-card__chart"
      style="width: 100%">
    </div>

    <div *ngIf="hasError" class="horizontal-bar-card__error">
      <app-data-error [message]="errorMessage" />
    </div>
  </div>
</div>
</ng-template>
